module.exports = __webpack_public_path__ + "media/images/gobpe-380d0fa7e3f5c883f1bb69005b90c634.png";